import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTED_PETITIONS_DISABLE_USER_SIGNATURE_FETCH = createFcmDetails(
	'promoted_petitions_disable_user_signature_fetch',
	{
		owner: 'Site Platform',
		context: 'promotion-service',
		import: false,
		description:
			'Disables the user signature fetch call for removing user signed petitions from the list of returned promoted petitions.',
	},
);
